/* global axios */
import ApiClient from './ApiClient';

// 定制: 尘锋推送日志查询(「名片推送日志」页数据源)
class DustessPushLogAPI extends ApiClient {
  constructor() {
    super('dustess_push_logs', { accountScoped: true });
  }

  get(page = 1) {
    return axios.get(`${this.url}?page=${page}`);
  }
}

export default new DustessPushLogAPI();
